import MarcaManagementPage from '../pages/MarcaManagementPage'

const routes = [
    { name: 'MarcaManagementPage', path: '/marca-management', component: MarcaManagementPage },
]

export default routes;
